export default "__VITE_ASSET__iZdKsE3S__"